import { createRestSlice } from "./restSlice";

export type Organization = {
  id: string;
  name: string;
  tier: string;
  billingEnabled: boolean;
  outboundEnabled: boolean;
  phoneNumberMonthlyRate?: number;
  agentCount: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const organizationSlice = createRestSlice<Organization>("organization", "/v1/organizations");

export const organizationReducer = organizationSlice.reducer;
export const organizationActions = organizationSlice.actions;
